/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".row[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto}.noDataWrapper[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;height:180px}.save[_ngcontent-%COMP%]{height:36px;border-radius:3px;background-color:#467fcf;color:#fff;width:96px}.edit-add-button[_ngcontent-%COMP%]{margin-left:auto;margin-right:24px;margin-top:20px;text-align:right}\n/*# sourceMappingURL=fraud-view.component.css.map*/"];
export { styles as styles };
